// marketerTerminal.js — 마케터 등록·수정 창의 '단말기 ID' 칸 (2026-10-21)
//   사용자: "마케터 수정 누르면 단말기 ID 왜 안떠! 어디다 적어" / "등록시에도 마찬가지야".
//   9/9 마케팅명부 화면을 없애며 그 창의 단말기 칸이 직원관리 마케터 창으로 옮겨지지 않았다.
//   칸 값 = 그 화면 마케터 탭 '단말기 ID' 열과 같은 값:
//     본사(자기 회사) 화면 — users.terminal_id (본사 매출관리 카드승인 맞추기). 마케터 저장에 같이 싣는다.
//     회사(ext) 화면       — user_terminal_ids[회사]. 저장이 끝난 뒤 PUT /api/admin/ext/:code/terminal-users/:id.
import { apiClient } from '../../../api/apiClient';

export const isExtApiBase = (apiBase) => String(apiBase || '').startsWith('/api/admin/ext/');

/** 창을 열 때 — row = 탭 줄(terminal_ids 포함), latest = 상세(users.*) */
export function marketerTerminalFields({ apiBase, companyCode, row, latest }) {
  const value = isExtApiBase(apiBase)
    ? String(row?.terminal_ids?.[companyCode] || '')
    : String(latest?.terminal_id || row?.terminal_id || '');
  return { terminal_id: value, original_terminal_id: value };
}

/** 본사 화면이면 마케터 저장 내용에 본사 단말기를 싣는다 */
export function addHqTerminal(payload, { apiBase, form }) {
  if (!isExtApiBase(apiBase)) payload.terminal_id = String(form.terminal_id || '').trim() || null;
}

/** 회사 화면이면 저장 뒤 회사 단말기를 따로 저장한다. 실패 문구를 돌려준다(성공·변화 없음은 null). */
export async function saveCompanyTerminal({ apiBase, companyCode, userId, form }) {
  if (!isExtApiBase(apiBase) || !userId) return null;
  const next = String(form.terminal_id || '').trim();
  if (next === String(form.original_terminal_id || '').trim()) return null;
  const r = await apiClient.put(`/api/admin/ext/${companyCode}/terminal-users/${userId}`, { terminal_id: next || null });
  return r.ok ? null : (r.data?.message || '단말기 ID 저장에 실패했습니다. 마케터 정보는 저장됐습니다.');
}
